import { AbstractFormatObjectAlert } from "./AbstractFormatObjectAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";

export class DuplicatedObjectIdAlert extends AbstractFormatObjectAlert {
  constructor(object: IFormatObjectEditable) {
    super(object, true);
  }

  get kind(): string {
    return "ID警告";
  }

  get description(): string {
    return "重複しているため、登録できません。";
  }
}
